var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 80,
    height: 80,
    viewBox: "0 0 226 226",
    style: {
      fill: "#000000"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,226v-226h226v226z",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#2b2b2b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224.99359,204.97141l-108.07391,-187.20922c-1.62438,-2.78969 -6.215,-2.78969 -7.83938,0l-108.48,187.89781c-0.79453,1.39484 -0.79453,3.12516 0,4.52c0.81219,1.39484 2.31297,2.26 3.91969,2.26h216.96c0.03531,0 0.07062,0 0.08828,0c2.50719,0 4.52,-2.01281 4.52,-4.52c0,-1.13 -0.40609,-2.15406 -1.09469,-2.94859zM106.18469,87.08063c0,-0.97109 0.65328,-1.62438 1.62438,-1.62438h10.38187c0.97109,0 1.60672,0.65328 1.60672,1.62438v65.36344c0,0.97109 -0.63562,1.62438 -1.60672,1.62438h-10.38187c-0.97109,0 -1.62438,-0.65328 -1.62438,-1.62438zM120.13313,180.5175c0,0.97109 -0.65328,1.60672 -1.60672,1.60672h-11.03516c-0.97109,0 -1.60672,-0.65328 -1.60672,-1.60672v-11.84734c0,-0.97109 0.65328,-1.60672 1.60672,-1.60672h11.03516c0.97109,0 1.60672,0.63563 1.60672,1.60672z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconError);
export default __webpack_public_path__ + "static/media/icon-error.ec0ebe22303cdef548554fa6191a5cda.svg";
export { ForwardRef as ReactComponent };